import React from 'react';
import { AppBar } from '@kambi/spark';

import classes from './Header.module.css';
import { useNavigate } from 'react-router-dom';
const Header = () => {
    const navigate = useNavigate();
    return (
        <div className={classes.Header} onClick={() => navigate('/')}>
            <AppBar toolName={'Kambi Betting Client Helpers'} />
        </div>
    );
};

export default Header;
